import { defineStore } from "pinia"
import { useResearchDataApi } from "./ResearchDataApi"
import { useTokenManager } from "@webapp/auth/TokenManager"
import { AsyncData, LoadMode } from "@webapp/util/AsyncData"
import { AsyncDataStore } from "@webapp/util/AsyncDataStore"

export const SyncChangesFeature = "SyncChanges"
export const MatchingGameFeature = "MatchingGame"

export const useFeatureStore = defineStore("featureStore", () => {
    const rd = useResearchDataApi()
    const tokenManager = useTokenManager()

    const asyncFeatures = new Map<string, AsyncData<boolean>>()

    function getAsyncFeatureEnabled(feature: string, loadMode = LoadMode.TrackOnly) {
        const store = useFeatureStore() // use to get/return reactive store objects
        const userId = tokenManager.current.userId
        if (!userId)
            return undefined

        const loadAsync = async () => {
            const enabled = await rd.getPlainAsync(`features/${feature}/${userId}/enabled`)
            return new Map([[feature, enabled === true]])
        }
        return AsyncDataStore.getAsyncItemsByIds(store.asyncFeatures, [feature], "Feature.Enabled", loadMode, loadAsync)[0]
    }

    /**
     * Returns whether the feature is enabled for the current user. Undefined means not known yet;
     * false means signed out, disabled, or the flag could not be read.
     */
    function isFeatureEnabled(feature: string) {
        const asyncEnabled = getAsyncFeatureEnabled(feature, LoadMode.EnsureLoaded)
        if (!asyncEnabled)
            return false
        return asyncEnabled.isLoadComplete() ? asyncEnabled.data === true : undefined
    }

    return {
        asyncFeatures,

        getAsyncFeatureEnabled,
        isFeatureEnabled,
    }
})
